var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgP1AlertAgileOr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 140,
    viewBox: "0 0 233 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3667_24694",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 233,
    height: 140
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(42px)",
      clipPath: "url(#bgblur_0_3667_24694_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 84,
    d: "M0.199951 5C0.199951 2.23857 2.43853 0 5.19995 0H227.2C229.961 0 232.2 2.23858 232.2 5V135C232.2 137.761 229.961 140 227.2 140H5.19995C2.43853 140 0.199951 137.761 0.199951 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3667_24694)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M246.862 31.4273C250.507 30.8409 254.081 32.809 255.518 36.1942L291.93 121.941C293.265 125.085 292.444 128.727 289.888 131.004L216.514 196.365C214.426 198.225 211.516 198.866 208.838 198.056L137.261 176.419C134.357 175.542 132.201 173.105 131.692 170.125L120.965 107.359C120.61 105.279 121.096 103.143 122.317 101.418L160.272 47.7937C161.516 46.0359 163.419 44.8515 165.55 44.5086L246.862 31.4273Z",
    fill: "#FF544F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.056 33.0756C207.538 31.7541 210.533 31.8336 212.942 33.285L274.944 70.6344C277.611 72.2408 279.103 75.2484 278.77 78.3437L270.701 153.275C270.543 154.739 269.985 156.131 269.087 157.297L215.126 227.412C212.01 231.462 205.946 231.591 202.66 227.678L145.553 159.668C144.533 158.453 143.897 156.963 143.727 155.385L135.124 75.9858C134.771 72.7355 136.432 69.598 139.318 68.062L205.056 33.0756Z",
    stroke: "#FF544F",
    strokeWidth: 2.81853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.027 120C203.121 120 212.114 111.046 212.114 100C212.114 88.9543 203.121 80 192.027 80C180.934 80 171.941 88.9543 171.941 100C171.941 111.046 180.934 120 192.027 120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9 94.7031C190.539 94.7031 189.436 95.8969 189.436 97.3686V108.712C189.436 110.185 190.54 111.378 191.9 111.378C193.261 111.378 194.363 110.184 194.363 108.712V97.3686C194.363 95.8969 193.26 94.7031 191.9 94.7031Z",
    fill: "#FF544F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9 93.3291C193.261 93.3291 194.363 92.1353 194.363 90.6635C194.363 89.191 193.26 87.998 191.9 87.998C190.54 87.998 189.436 89.1918 189.436 90.6635C189.435 92.1353 190.539 93.3291 191.9 93.3291Z",
    fill: "#FF544F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3667_24694_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.199951 5C0.199951 2.23857 2.43853 0 5.19995 0H227.2C229.961 0 232.2 2.23858 232.2 5V135C232.2 137.761 229.961 140 227.2 140H5.19995C2.43853 140 0.199951 137.761 0.199951 135V5Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgP1AlertAgileOr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/p1Alert_agileOr.b7a8f9272302023a20f60607952235e1.svg";